<i18n>
{
    "en":{
      "please_input_captcha": "Please input the captcha",
      "error_captcha": "Captcha is wrong",
      "title": "Watch the AD to get free trial",
      "no_available_trial_device": "You've used up today's free trial sessions. Subscribe to unlock unlimited playtime anytime — or come back tomorrow for another free session!",
      "trial_cool_down_1d": "You've used 20 or more free trials, so you can now start 1 free trial per day. Subscribe for unlimited playtime anytime!",
      "trial_cool_down_3d": "You've used 100 or more free trials, so you can now start 1 free trial every 3 days. Subscribe for unlimited playtime anytime!",
      "trial_cool_down_7d": "You've used 200 or more free trials, so you can now start 1 free trial every 7 days. Subscribe for unlimited playtime anytime!",
      "sub_title": "Watch the Full Introduction Video",
      "trial_plan_had_applied": "You already have a free trial license.",
      "paymentProblemQuestion": "Thank you very much for using our product, and we guarantee continued unlimited free trials. However, I would like to ask if you have encountered any difficulties in paying for it?",
      "other": "Other",
      "noCreditCard": "No credit card / debit card, unable to pay",
      "tooExpensive": "Too expensive",
      "submit": "Submit",
      "try_later": "Try later",
      "subscribe_now": "Subscribe now"
    },
    "zhHant":{
      "please_input_captcha": "請輸入驗證碼",
      "error_captcha": "驗證碼錯誤",
      "title": "看完廣告取得免費試用",
      "no_available_trial_device": "今天的免費試用次數已用完。訂閱即可解鎖無限時數，隨時想玩就玩；或者明天再回來繼續免費試用！",
      "trial_cool_down_1d": "你的免費試用已累計 20 次以上，現在每天只能試用 1 次。訂閱即可解除限制，隨時想玩就玩！",
      "trial_cool_down_3d": "你的免費試用已累計 100 次以上，現在每 3 天只能試用 1 次。訂閱即可解除限制，隨時想玩就玩！",
      "trial_cool_down_7d": "你的免費試用已累計 200 次以上，現在每 7 天只能試用 1 次。訂閱即可解除限制，隨時想玩就玩！",
      "sub_title": "觀看完整介紹影片",
      "trial_plan_had_applied": "您已取得免費試用授權。",
      "paymentProblemQuestion": "非常感謝您使用我們的產品，我們保證持續提供無限次數的免費試用。不過想請問您對於付費使用方面，是否遇到什麼困難？",
      "other": "其他",
      "noCreditCard": "沒有信用卡/簽帳卡，無法付款",
      "tooExpensive": "覺得太貴",
      "submit": "提交",
      "try_later": "稍後再試",
      "subscribe_now": "立即訂閱"
    },
    "ja":{
      "please_input_captcha": "画像に表示された文字を入力してください",
      "error_captcha": "入力された文字が正しくありません。もう一度お試しください。",
      "title": "広告を見て無料トライアルを獲得",
      "no_available_trial_device": "本日の無料トライアル回数が上限に達しました。ご登録いただくと時間無制限でいつでもご利用いただけます。もちろん、明日また無料でお試しいただくこともできます！",
      "trial_cool_down_1d": "無料トライアルのご利用が累計20回以上になったため、今後は1日1回までのご利用となります。ご登録いただくと、時間無制限でいつでもご利用いただけます！",
      "trial_cool_down_3d": "無料トライアルのご利用が累計100回以上になったため、今後は3日に1回までのご利用となります。ご登録いただくと、時間無制限でいつでもご利用いただけます！",
      "trial_cool_down_7d": "無料トライアルのご利用が累計200回以上になったため、今後は7日に1回までのご利用となります。ご登録いただくと、時間無制限でいつでもご利用いただけます！",
      "sub_title": "紹介動画を最後まで見る",
      "trial_plan_had_applied": "お客様は現在無料トライアル中です。",
      "paymentProblemQuestion": "いつもご利用いただきありがとうございます。無料トライアルは今後も回数無制限でご利用いただけます。もしよろしければ、お支払いについて何かお困りの点がなかったか教えていただけますか？",
      "other": "その他",
      "noCreditCard": "クレジットカード・デビットカードがなく、お支払いができない",
      "tooExpensive": "料金が高い",
      "submit": "送信",
      "try_later": "後で試す",
      "subscribe_now": "今すぐ登録する"
    },
    "ko":{
      "please_input_captcha": "캡차를 입력하세요",
      "error_captcha": "캡차가 틀렸습니다",
      "title": "광고를 보고 무료로 써보세요",
      "no_available_trial_device": "오늘의 무료 체험 횟수를 모두 사용했습니다. 지금 구독하면 시간 제한 없이 언제든 이용할 수 있어요. 물론 내일 다시 무료 체험도 가능합니다!",
      "trial_cool_down_1d": "무료 체험을 누적 20회 이상 이용하셔서 이제 하루에 1번만 체험할 수 있어요. 구독하면 시간 제한 없이 언제든 이용할 수 있어요!",
      "trial_cool_down_3d": "무료 체험을 누적 100회 이상 이용하셔서 이제 3일에 1번만 체험할 수 있어요. 구독하면 시간 제한 없이 언제든 이용할 수 있어요!",
      "trial_cool_down_7d": "무료 체험을 누적 200회 이상 이용하셔서 이제 7일에 1번만 체험할 수 있어요. 구독하면 시간 제한 없이 언제든 이용할 수 있어요!",
      "sub_title": "전체 소개 비디오 시청하기",
      "trial_plan_had_applied": "무료로 시험 사용 허가를 받았습니다",
      "other": "기타",
      "paymentProblemQuestion": "저희 제품을 이용해 주셔서 진심으로 감사드리며, 지속적인 무제한 무료 평가판을 보장합니다. 그런데 혹시 결제하는데 어려움은 없으셨는지 여쭤보고 싶습니다.",
      "noCreditCard": "신용/직불카드 없이는 결제가 불가능합니다.",
      "tooExpensive": "너무 비싸요",
      "submit": "제출",
      "try_later": "나중에 다시 시도",
      "subscribe_now": "즉시 구독하기"
    }
}
</i18n>
<template>
  <v-layout column fill-height justify-space-between>
    <div v-if="showCaptcha" class="text-xs-center" style="margin-top: 200px">
      <canvas width="240" height="90" id="captcha1"></canvas>
      <v-text-field
        v-model="captchaValue"
        @input="onInputCaptcha"
        :label="$t('please_input_captcha')"
        :error-messages="captchaError"
        style="margin-left: 40px; margin-right: 40px"
      ></v-text-field>
    </div>
    <div v-if="showAd">
      <div class="text-xs-center" style="margin-top: 20px; font-size: 20px; padding: 0 20px">
        {{ this.$i18n.t('title') }}
      </div>

      <div style="display: flex; flex-direction: column; justify-content: center; flex-grow: 1">
        <div style="display: flex; flex-direction: column; align-items: center">
          <iframe
            style="max-width: 560px; width: 100%; height: 315px; border: 0"
            :src="`https://www.youtube.com/embed/${youtubeID}?autoplay=1&mute=1`"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <a :href="`https://www.youtube.com/watch?v=${youtubeID}`" target="_blank" style="text-decoration: none">
            <div style="color: #3874cb; font-size: 20px; margin-top: 20px">
              {{ this.$i18n.t('sub_title') }}
            </div>
          </a>
        </div>
      </div>

      <v-progress-linear height="2" v-model="progressLinearValue" color="cyan" style="margin-bottom: 0">
      </v-progress-linear>

      <!-- survey dialog -->
      <v-dialog v-model="isSurveyDialogOpen" persistent max-width="400">
        <v-card>
          <v-card-title>{{ $t('paymentProblemQuestion') }}</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="isPaymentReasonValid" lazy-validation>
              <v-radio-group v-model="paymentReason" validate-on-blur :rules="paymentReasonFormRules">
                <v-radio :label="$t(reasons.noCreditCard)" :value="reasons.noCreditCard" />
                <v-radio :label="$t(reasons.tooExpensive)" :value="reasons.tooExpensive" />
                <v-radio :label="$t(reasons.other)" :value="reasons.other" />
                <v-textarea outline v-model="otherReason" :rules="otherReasonRules" />
              </v-radio-group>
            </v-form>
            <HighPriceHint :isShow="paymentReason === reasons.tooExpensive" :supportGame="supportGame" />
            <NoCreditCardHint :isShow="paymentReason === reasons.noCreditCard" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              small
              :color="isPaymentReasonValid ? 'primary' : 'blue-grey lighten-4'"
              outline
              @click="submitSurvey"
              >{{ $t('submit') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="isTrialExhaustedDialogOpen" persistent max-width="400">
      <v-card>
        <v-card-text class="pt-4">{{ trialExhaustedMessage || $t('no_available_trial_device') }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn outline @click="onTryLater">{{ $t('try_later') }}</v-btn>
          <v-btn color="primary" @click="onSubscribeNow">{{ $t('subscribe_now') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/functions';
import { trackAbConvert } from '@/misc/ab';
import HighPriceHint from '../components/HighPriceHint';
import NoCreditCardHint from '../components/NoCreditCardHint';
import CaptchaMini from 'captcha-mini';

const xApplyTrialPlan = firebase.functions().httpsCallable('xApplyTrialPlan');
const xCheckTrialPlan = firebase.functions().httpsCallable('xCheckTrialPlan');

export default {
  name: 'trial',
  components: {
    HighPriceHint,
    NoCreditCardHint,
  },
  data() {
    return {
      showCaptcha: false,
      showAd: false,
      captchaAnswer: '',
      captchaValue: '',
      catchaError: '',
      waitTime: 45000,
      progressLinearValue: 100,
      countdownTimer: undefined,
      youtubeID: undefined,
      youtubePossibleIDs: {
        tsum: {
          en: ['JSmbshC4TDE'],
          zhHant: ['JSmbshC4TDE'],
          ja: ['8dAU4LLraWs', 'yjivg-L9opI', 'nAmCZay2Zs8', 'JSmbshC4TDE'],
          ko: ['JSmbshC4TDE'],
        },
        cookieKingdom: {
          en: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
          zhHant: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
          ja: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
          ko: ['TBtwHMk8eBQ', 'qUrkv-Z-vPE'],
        },
        mlb9i: {
          en: ['8dAU4LLraWs'],
          zhHant: ['8dAU4LLraWs'],
          ja: ['8dAU4LLraWs'],
          ko: ['8dAU4LLraWs'],
        },
      },
      isSurveyDialogOpen: false,
      isTrialExhaustedDialogOpen: false,
      trialExhaustedMessage: '',
      reasons: {
        noCreditCard: 'noCreditCard',
        tooExpensive: 'tooExpensive',
        other: 'other',
      },
      paymentReason: undefined,
      otherReason: '',
      isPaymentReasonValid: false,
      paymentReasonFormRules: [v => v === this.reasons.other && !this.otherReason.trim() && '', v => !v && ''],
      otherReasonRules: [v => this.paymentReason === this.reasons.other && !v && ''],
    };
  },
  async mounted() {
    this.supportGame = this.$route.params.supportGame;
    if (this.supportGame !== 'tsum' && this.supportGame !== 'cookieKingdom' && this.supportGame !== 'mlb9i') {
      this.$router.push({ name: 'home' });
      return;
    }
    await this.checkFreeTrial();
  },
  methods: {
    countdown() {
      if (this.countdownTimer !== undefined) {
        return;
      }
      const now = Date.now();
      this.countdownTimer = setInterval(async () => {
        this.progressLinearValue = 100 - ((Date.now() - now) / this.waitTime) * 100;
        if (this.progressLinearValue <= 0) {
          clearInterval(this.countdownTimer);
          this.progressLinearValue = 0;
          await this.applyFreeTrial();
        }
      }, 1000);
    },
    handleTrialError(error) {
      let code = error.code;
      if (code === 'already-exists') {
        alert(this.$i18n.t('trial_plan_had_applied'));
        this.$router.push({ name: 'home' });
      } else if (code === 'resource-exhausted') {
        this.isTrialExhaustedDialogOpen = true;
      } else if (error === 'failed-precondition') {
        this.$router.push('/login');
      } else {
        alert(error);
        this.$router.push({ name: 'home' });
      }
    },
    // Trial rule errors returned as a result instead of a thrown error.
    handleTrialErrorResult(data) {
      this.$gtag.event('freeTrial', 'issueError', data.errorCode, 1);
      const i18nKeys = {
        'trial-cool-down-1d': 'trial_cool_down_1d',
        'trial-cool-down-3d': 'trial_cool_down_3d',
        'trial-cool-down-7d': 'trial_cool_down_7d',
      };
      const key = i18nKeys[data.errorCode];
      // Unknown codes fall back to the default no_available_trial_device message.
      this.trialExhaustedMessage = key ? this.$t(key) : '';
      this.isTrialExhaustedDialogOpen = true;
    },
    onTryLater() {
      this.isTrialExhaustedDialogOpen = false;
      this.$router.push({ name: 'home' });
    },
    onSubscribeNow() {
      this.isTrialExhaustedDialogOpen = false;
      this.$router.push(`/plan/${this.supportGame}`);
    },
    async onInputCaptcha() {
      if (this.captchaAnswer === this.captchaValue) {
        this.showCaptcha = false;
        this.showAd = true;

        // trial times >= 10
        this.$gtag.event('freeTrial', 'issueSuccess', 'showAds', 1);
        const hasFinishSurvey = localStorage.getItem('hasFinishSurvey');
        if (hasFinishSurvey === null) {
          this.isSurveyDialogOpen = true;
        } else {
          const links = this.youtubePossibleIDs[this.supportGame][this.$i18n.locale];
          if (links.length > 0) {
            const randomIndex = Math.floor(Math.random() * links.length);
            this.youtubeID = links[randomIndex];
          }
          this.countdown();
        }
      } else {
        if (this.captchaValue.length >= 4) {
          this.captchaError = this.$t('error_captcha');
        }
      }
    },
    async checkFreeTrial() {
      let result;
      try {
        result = await xCheckTrialPlan({
          supportGame: this.supportGame,
        });
      } catch (error) {
        this.$gtag.event('freeTrial', 'issueError', error.code, 1);
        this.handleTrialError(error);
        return;
      }
      if (result.data && result.data.errorCode) {
        this.handleTrialErrorResult(result.data);
        return;
      }
      const showAd = result.data ? result.data.showAd : false;
      if (!showAd) {
        await this.applyFreeTrial();
        return;
      }

      this.showCaptcha = true;
      this.$nextTick(() => {
        let captcha1 = new CaptchaMini();
        captcha1.draw(document.querySelector('#captcha1'), r => {
          this.captchaValue = '';
          this.captchaError = '';
          this.captchaAnswer = r;
        });
      });
    },
    async applyFreeTrial() {
      try {
        const result = await xApplyTrialPlan({
          supportGame: this.supportGame,
        });
        if (result.data && result.data.errorCode) {
          this.handleTrialErrorResult(result.data);
          return;
        }
        this.$gtag.event('freeTrial', 'issueSuccess', 'noShowAds', 1);
        // Every trial path funnels through here, ad-gated or not.
        trackAbConvert('trial_start', firebase.auth().currentUser);
        this.$router.push({ name: 'home' });
      } catch (error) {
        this.$gtag.event('freeTrial', 'issueError', error.code, 1);
        this.handleTrialError(error);
      }
    },
    validate() {
      return this.$refs.form.validate();
    },
    async submitSurvey() {
      if (!this.validate()) {
        return;
      }

      try {
        localStorage.setItem('hasFinishSurvey', true);
        const userInputReason =
          this.paymentReason === this.reasons.other ? this.otherReason : this.$t(this.paymentReason);
        const formContent = new FormData();

        formContent.append('UserID', firebase.auth().currentUser.uid);
        formContent.append('Name', firebase.auth().currentUser.displayName);
        formContent.append('Email', firebase.auth().currentUser.email);
        formContent.append('Message', userInputReason);
        formContent.append('Time', new Date().toISOString());

        fetch(
          'https://script.google.com/macros/s/AKfycby5WHqPJqYntaCnaGS1YhKuDQ2A5hktCLnGvSMyG5WcyGE56xNsgsS-_7wbWwPTddAg/exec',
          {
            method: 'POST',
            body: formContent,
          }
        );
      } catch (error) {
        console.error('send reason to google sheet failed: ', error);
      }
      this.isSurveyDialogOpen = false;
      await this.applyFreeTrial();
    },
  },
  beforeDestroy() {
    // deconstruction here!!
    clearInterval(this.countdownTimer);
  },
};
</script>
